<template>
  <div>
    <t-form labelWidth="90px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="标题">
          <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
        </t-form-item>
        <t-form-item label="标题大小">
          <t-input-number size="small" v-model="attribute.title.textStyle.fontSize" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="标题颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.title.textStyle.color"/>
        </t-form-item>
        <t-form-item label="标题位置(X)">
          <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="标题位置(Y)">
          <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="图例" :expand="false">
        <t-form-item label="图例显示">
          <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="图例位置(X)">
          <e-chart-position v-model="attribute.legend.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="图例位置(Y)">
          <e-chart-position v-model="attribute.legend.top" :direction="'y'"/>
        </t-form-item>
        <t-form-item label="图例布局方式">
          <t-radio-group v-model="attribute.legend.orient" size="small">
            <t-radio-button value="vertical">纵向</t-radio-button>
            <t-radio-button value="horizontal">横向</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="图例字体">
          <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="图例文字颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="内边距" :expand="false">
        <t-form-item label="内边距(左)">
          <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(上)">
          <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(右)">
          <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(下)">
          <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="x轴" :expand="false">
        <t-form-item label="x轴">
          <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="x轴文字">
          <t-switch v-model="attribute.xAxis.axisLabel.show"  :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="x轴指示文字">
          <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40"/>
        </t-form-item>
        <t-form-item label="x轴字体颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.xAxis.axisLabel.color"/>
        </t-form-item>
        <t-form-item label="x轴线显示">
          <t-switch v-model="attribute.xAxis.axisLine.show"  :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="x轴线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.xAxis.axisLine.lineStyle.color"/>
        </t-form-item>
        <t-form-item label="x轴刻度线">
          <t-switch v-model="attribute.xAxis.axisTick.show"  :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="边界间隙">
          <t-switch v-model="attribute.xAxis.boundaryGap"  :label="['开', '关']" size="small"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="y轴" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.yAxis.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="文字">
          <t-switch v-model="attribute.yAxis.axisLabel.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="根据范围渲染">
          <t-switch v-model="attribute.yAxisRangeRender" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="指示文字">
          <t-input v-model="attribute.yAxis.name" size="small" :maxcharacter="40"/>
        </t-form-item>
        <t-form-item label="字体颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.axisLabel.color"/>
        </t-form-item>
        <t-form-item label="线显示">
          <t-switch v-model="attribute.yAxis.axisLine.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.axisLine.lineStyle.color"/>
        </t-form-item>
        <t-form-item label="网格线">
          <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="网格线颜色" v-if="attribute.yAxis.splitLine.lineStyle">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.splitLine.lineStyle.color[0]"/>
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.splitLine.lineStyle.color[1]"/>
        </t-form-item>
        <t-form-item label="网格线样式">
          <t-radio-group v-model="attribute.yAxis.splitLine.lineStyle.type" size="small">
            <t-radio-button value="solid">实线</t-radio-button>
            <t-radio-button value="dashed">虚线</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="刻度线">
          <t-switch v-model="attribute.yAxis.axisTick.show" :label="['开', '关']" size="small"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="数值" :expand="true">
        <t-form-item label="数值显示">
          <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="数值字体">
          <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="数值颜色" v-show="attribute.series.label.color">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small"/>
        </t-form-item>
        <t-form-item label="数值位置" v-show="attribute.series.label.position">
          <t-select v-model="attribute.series.label.position" size="small">
            <t-option label="顶部" value="top"/>
            <t-option label="左" value="left"/>
            <t-option label="右" value="right"/>
            <t-option label="底部" value="bottom"/>
            <t-option label="中心" value="inside"/>
          </t-select>
        </t-form-item>
      </e-collapse>
      <e-collapse title="折线" :expand="true">
        <t-form-item label="折线显示">
          <t-switch v-model="attribute.lineShow" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="平滑曲线">
          <t-switch v-model="attribute.smooth" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="折线配色">
          <e-color-group v-model="attribute.lineColors" :max="20" :gradient="false"/>
        </t-form-item>
        <t-form-item label="圆点大小">
          <t-input-number size="small" v-model="attribute.symbolSize" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="面积显示">
          <t-switch v-model="attribute.areaShow" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="面积配色">
          <e-color-group v-model="attribute.areaColors" :max="20" :gradient="true"/>
        </t-form-item>
      </e-collapse>
      <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
         <t-switch v-model="attribute.dataZoom.show"/> 
      </t-form-item>
      <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
         <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
      </t-form-item>
    </t-form>
  </div>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group";
import EChartPosition from "@/components/designer/e-chart-position";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-line-option",
  components: {EChartPosition, EColorGroup,CptData},
  props: {attribute: Object,cptDataForm:Object,},
}
</script>

<style scoped>
</style>
